<template>
  <div class="main">
    <Sidebar
        :current-keywords="keywords"
        :current-filters="currentFilters"
        @search="setKeywords"
        :filter-types="filterTypes"
        @add-filter="addFilter"
        @remove-filter="removeFilter"
        @remove-all-filters="removeAllFilters"/>

    <div class="title-bar">
      <h1>System Logs</h1>
      <AdminMenu class="pt-2" current="System" />
    </div>

    <div class="d-flex px-3 pt-3 file-folder-tabs-wrap">
      <SystemLogTabs current="User Logins" />
    </div>

    <div class="content p-3">
      <div class="row">
        <div class="col-12">
          <div class="row d-none d-xl-flex">
            <div class="col-12 col-xl-4 mb-3 mb-xl-0 text-center text-xl-left">
              <a
                v-if="items.length > 0"
                href="#"
                @click.prevent="showExportOptions()"
                class="btn btn-info mb-3 mr-sm-1 mb-sm-0 mb-xl-3"
              >
                <span class="icon icon-download"></span>
                <span class="text">Export List</span>
              </a>
            </div>
            <div class="col-12 col-xl-4 mb-3 mb-xl-0 text-center">
              <Pagination
                class="d-inline-block"
                :total="totalPages"
                :value="parseInt(pagination.current)"
                @input="setCurrentPage"
              />
            </div>
            <div class="col-12 col-xl-4 text-center text-xl-right">
              <PageSize
                :value="parseInt(pagination.per_page)"
                @input="setPerPage"
              />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ListTable
                :items="items"
                :columns="columns"
                :activeColumns="activeColumns"
                :hideNoResults="hideNoResults"
                @sort-by="setSort"
                @swap-column="setActiveColumn"
              >
                <template v-slot:col_created_at="{ item }"
                  >{{
                    item.created_at | moment("M/D/YYYY h:mma")
                  }}
                  EST</template
                >
              </ListTable>
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-xl-4 mb-3 mb-xl-0 text-center text-xl-left">
              <a
                v-if="items.length > 0"
                href="#"
                @click.prevent="showExportOptions()"
                class="btn btn-info mb-3 mr-sm-1 mb-sm-0 mb-xl-3"
              >
                <span class="icon icon-download"></span>
                <span class="text">Export List</span>
              </a>
            </div>
            <div class="col-12 col-xl-4 mb-3 mb-xl-0 text-center">
              <Pagination
                class="d-inline-block"
                :total="totalPages"
                :value="parseInt(pagination.current)"
                @input="setCurrentPage"
              />
            </div>
            <div class="col-12 col-xl-4 text-center text-xl-right">
              <PageSize
                :value="parseInt(pagination.per_page)"
                @input="setPerPage"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ListingMixin from "mixins/Listing";
import AdminMenu from "../partials/AdminMenu";
import SystemLogTabs from "./partials/SystemLogTabs";

export default {
  mixins: [ListingMixin],
  components: { AdminMenu, SystemLogTabs },
};
</script>
